import metalSprite from '../assets/hideout_metal_sprite.svg'
import planksSprite from '../assets/hideout_planks_sprite.svg'
import treesSprite from '../assets/hideout_trees_sprite.svg'
import type { HideoutTierId } from '../game/types'

type Props = {
  tierId: HideoutTierId
  label: string
  tierName: string
}

const TIER_BACKGROUND_IMAGE: Record<HideoutTierId, string> = {
  forest_hideout: treesSprite,
  boarded_workplace: planksSprite,
  train_depot: metalSprite,
  utrecht_centrum: metalSprite,
}

const TIER_BACKGROUND_BRIGHTNESS: Record<HideoutTierId, string> = {
  forest_hideout: 'brightness(0.95)',
  boarded_workplace: 'brightness(0.88)',
  train_depot: 'brightness(0.82)',
  utrecht_centrum: 'brightness(0.8)',
}

export function HideoutTierBanner({ tierId, label, tierName }: Props) {
  return (
    <div className="relative overflow-hidden rounded-md border border-stone-800/80">
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `url(${TIER_BACKGROUND_IMAGE[tierId]})`,
          backgroundSize: 'cover auto',
          backgroundPosition: 'center',
          backgroundRepeat: 'repeat-x',
          filter: TIER_BACKGROUND_BRIGHTNESS[tierId],
        }}
      />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(0,0,0,0.15),rgba(0,0,0,0.86))]" />
      <p className="relative px-2 py-1.5 text-[10px] uppercase tracking-wider text-stone-300">
        {label}: <span className="text-stone-100">{tierName}</span> 
      </p>
    </div>
  )
}
